import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  const { t } = useTranslation();
  const waLink = "https://wa.me/33783977370?text=" + encodeURIComponent("Bonjour, je souhaite réserver un VTC sur la Côte d'Azur.");

  return (
    <section data-testid="cta-section" className="py-14 md:py-20 relative overflow-hidden bg-gradient-to-br from-[#050505] via-[#0F1115] to-[#050505]">
      <div className="absolute inset-0 bg-grain opacity-30" />
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 lg:px-12 relative z-10 text-center max-w-2xl">
        <h2 className="font-editorial text-3xl md:text-4xl font-light text-white mb-6 tracking-tight">{t("cta.title")}</h2>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link
            to="/#booking"
            data-testid="cta-book-btn"
            className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-full text-xs font-semibold uppercase tracking-wider"
          >
            {t("cta.book")} <ArrowRight size={14} />
          </Link>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-xs font-semibold uppercase tracking-wider bg-[#128C7E] hover:bg-[#0e6d61] text-white transition-all"
          >
            {t("cta.whatsapp")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
